import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ENVIRONMENT, EnvironmentAppNames } from 'environments';

@Component({
  selector: 'router-outlet-wrapper',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styleUrl: './router-outlet-wrapper.component.scss',
  host: {
    '[style.background-color]': 'clinic && !BODACDC_3187 ? "#F2F2F2" : null',
    '[style.display]': 'clinic && !BODACDC_3187 ? "flex" : null',
    '[style.justify-content]': 'clinic && !BODACDC_3187 ? "center" : null',
    '[style.align-items]': 'clinic && !BODACDC_3187 ? "center" : null',
    '[style.width]': 'clinic && !BODACDC_3187 ? "100%" : null',
    '[class.bodacdc-3187]': 'clinic && BODACDC_3187',
  },
})
export class RouterOutletWrapperComponent {
  private environment = inject(ENVIRONMENT);
  BODACDC_3187 = FEATURE_BODACDC_3187;
  clinic = this.environment.constants.app_name === ('clinic' as EnvironmentAppNames);
}
